<template>
  <v-dialog v-model="show" persistent max-width="360">
    <v-card>
      <v-card-title>
        {{ $t('organization_settings.create_api_key') }}
      </v-card-title>

      <v-card-text class="message">{{
        $t('organization_settings.create_api_key_description')
      }}</v-card-text>

      <v-card-text>
        <v-text-field
          required
          autocomplete="off"
          autofocus
          class="mb-2"
          data-private
          dense
          outlined
          v-model="name"
          data-tourid="apikeys-textField-name"
          @keydown.enter="handleCreate"
          :disabled="isLoading"
          :label="`${$t('organization_settings.api_key_name')}*`"
          :rules="[
            name => !!name || $t('validation.form.this_field_is_required'),
          ]"
        />
      </v-card-text>

      <v-card-actions class="justify-end">
        <Button
          plain
          color="grey"
          :disabled="isLoading"
          :text="$t('common.button.cancel')"
          @click="$emit('cancel')"
        />

        <Button
          color="primary"
          plain
          :loading="isLoading"
          :text="$t('common.create')"
          @click="handleCreate"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Button from '@/components/UI/Button'
export default {
  name: 'APIKeysCreateModal',
  components: {
    Button,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false,
    },
  },

  data() {
    return {
      isLoading: false,
      name: '',
    }
  },

  watch: {
    show() {
      this.name = ''
    },
  },

  methods: {
    async handleCreate() {
      if (!this.name) return

      this.$emit('created', {
        name: this.name,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.message {
  white-space: pre;
}
</style>
